module.exports = __webpack_public_path__ + "body-special-bg-shape-03.png?ef54f44dc7c827dfe3c428065ef59e75";